// extracted by mini-css-extract-plugin
module.exports = {"osaAnalyse":"osaAnalyse___39VOG","search":"search___1U0rp"};